import moment from "moment";
//the value should be the offset from current week
const WEEK_OFFSETS = [
  {
    label: "Current Week",
    value: "current",
  },
  {
    label: "1 Week Ago",
    value: "1,1",
  },
  {
    label: "2 Weeks Ago",
    value: "2,2",
  },
  {
    label: "3 Weeks Ago",
    value: "3,3",
  },
  {
    label: "4 Weeks Ago",
    value: "4,4",
  },
  {
    label: "5 Weeks Ago",
    value: "5,5",
  },
];

const DAY_OFFSETS = [
  {
    label: "Last 30",
    value: "0,30",
  },
  {
    label: "30-60 Days Ago",
    value: "31,61",
  },
  {
    label: "60-90 Days Ago",
    value: "62,92",
  },
];

const generateOptions = (maxCount, getLabel) => {
  let options = [];
  for (let i = 1; i < maxCount; i++) {
    options = [
      ...options,
      {
        label: getLabel(i),
        value: `${i},${i}`,
      },
    ];
  }
  return options;
};

const calculateMonthOffsets = () => {
  const currentMonth = moment().format("MMMM");
  return [
    {
      label: `${currentMonth} (current)`,
      value: "current",
    },
    ...generateOptions(13, (i) => {
      return moment()
          .subtract(i, "months")
          .format("MMMM YYYY")
    })
  ];
};

const calculateQuarterOffsets = () => {
  const currentQuarter = moment().quarter();
  const currentYear = moment().format("YYYY");
  return [
    {
      label: `Q${currentQuarter} ${currentYear} (current)`,
      value: "current",
    },
    ...generateOptions(5, (i) => {
      const date = moment().subtract(i, "quarter");
      const quarter = date.quarter();
      const year = date.format("YYYY");
      return `Q${quarter} ${year}`;
    }),
  ];
};

const calculateYearOffsets = () => {
  const currentYear = moment().format("YYYY");
  return [
    {
      label: `${currentYear} (current)`,
      value: "current",
    },
    ...generateOptions(6, (i) => {
      return moment()
            .subtract(i, "year")
            .format("YYYY");
    })
  ];
};


const PERIOD_OFFSETS = {
  "30": DAY_OFFSETS,
  week: WEEK_OFFSETS,
  month: calculateMonthOffsets(),
  quarter: calculateQuarterOffsets(),
  year: calculateYearOffsets(),
};

export const calculatePeriodOffsets = (period) => PERIOD_OFFSETS[period] || [];

